import { setVersionInEdicom } from '@edicom/common/edicom/setVersionInEdicom';
import { name, version } from './package.json';
import { edicomLocale } from './edicomLocale';

setVersionInEdicom(name, version);

// exponemos el servicio en la global "edicom.locale":
globalThis.edicom.locale = edicomLocale;
